// extracted by mini-css-extract-plugin
export default {"main":"globalerror_main__fs+Yu","header":"globalerror_header__1uYfW"};